import { AudioLevelAnalyser } from '../../../../helpers/analysers/audio-level-analyser';
import { getAudioContext } from '../../../../helpers/audio-context';

const audioContext = getAudioContext();
export const diagnosticAudioLevelAnalyser = audioContext ? new AudioLevelAnalyser(audioContext) : null;
